import { put, select, takeLeading } from 'redux-saga/effects'
import { ValidationConstants } from '../store/validation.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import validationService from '../services/validation.services'
import { convertStringToNumber } from '../../../utilities'
import { IDataToValidate, IValidationRequest, IValidationState } from '../store/validation.types'
import { getValidationSelector } from '../selectors/getValidation.selector'

export function* inputValidation() {
  try {
    const validation: IValidationState = yield select(getValidationSelector)

    const { currentAction, currentValue, currentInputValidationElement, ruleReadyActions, currentConditionalValue } =
      validation

    let currentInput = validationService.getActionType(currentAction)

    if (currentConditionalValue) {
      currentInput = currentInput + '_' + currentConditionalValue
    }

    const isNumber = validationService.isValidationMetadataForTypeNumber(currentAction)

    const dataToValidate: IDataToValidate = {
      [currentInput]: isNumber ? convertStringToNumber(currentValue) : currentValue,
    }

    const iValidationRequest: IValidationRequest = {
      currentAction,
      currentInput,
      currentValue,
      isNumber,
      dataToValidate,
      validateFunction: validationService.getValidateFunction(currentAction),
    }

    const iValidationResponse = validationService.validate(iValidationRequest)

    if (currentInputValidationElement) {
      currentInputValidationElement.innerHTML = iValidationResponse.errorMessage
    }

    if (iValidationResponse.isRuleReady) {
      ruleReadyActions.add(currentAction)
    } else {
      ruleReadyActions.delete(currentAction)
    }
  } catch (e) {
    yield put(throwPcrException(`inputValidation() error: ${e}`))
  }
}

export function* inputValidationSaga() {
  // Should we use takeLatest or takeLeading? (https://redux-saga.js.org/docs/api/)
  yield takeLeading([ValidationConstants.DO_INPUT_VALIDATION], inputValidation)
}
